var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_vm._m(0),_c('div',{staticClass:"return-button",on:{"click":_vm.returnHome}},[_vm._v("返回首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404-content"},[_c('img',{attrs:{"src":require("@/assets/images/icon-404.png"),"alt":""}}),_c('h6',[_vm._v("AH OH~ 页面找不到了！")]),_c('p',[_vm._v("也许探索AI知识之路，有时会迷航，但请相信，勿忘初心，")]),_c('p',[_vm._v("我们终将会抵达梦想的彼岸~")])])
}]

export { render, staticRenderFns }